<template>
  <div
    class="fc2"
    :class="{
      textarea: textarea,
      valued: valued,
      disabled: this.disabled,
      [fcType]: true,
      'no-disabled-style': noDisabledStyle,
      ...classDict,
    }"
    :style="{
      height: heightC,
      '--fc2-lw': lw,
      '--fc2-cw': cw,
      '--fc2-height': heightC,
      '--bb': bb || `1px solid var(--sprt-85)`,
    }"
  >
    <label v-if="showLabel" class="fc2-label txtov" :title="label" :for="id">
      <span>{{ label }} </span>
      <v-menu
        v-if="hint && hintHTML"
        open-on-hover
        bottom
        left
        offset-y
        max-width="768"
      >
        <img
          slot="activator"
          class="dt-icon v5 s20 fc2-hint"
          src="static/icons/help.svg"
          :alt="hint"
        />
        <v-card style="padding: 8px">
          <div>
            <div v-html="hint"></div>
          </div>
        </v-card>
      </v-menu>
      <img
        v-if="hint && !hintHTML"
        class="dt-icon v5 s20 fc2-hint"
        :title="hint"
        src="static/icons/help.svg"
        :alt="hint"
      />
    </label>
    <slot></slot>
  </div>
</template>
  
<script>
const INPUT_HEIGHT = 32;
const TEXTAREA_HEIGHT = 80;

export const FC2CommonProps = {
  lw: {
    type: String,
    default: "115px",
  },
  cw: {
    type: String,
    default: "auto",
  },
  
  bb: {
    type: String,
  },
  hint: {
    type: String,
  },
  hintHTML: {
    type: Boolean,
    default: false,
  },
  popup: {
    type: String,
  },
  popupType: {
    type: String,
    default: "text",
  },
  noDisabledStyle: {
    type: Boolean,
    default: false,
  },
  validationIconBG: {
    type: String,
    default: 'white'
  },
  overflowIndicator: {
    type: Boolean,
    default: true
  }
};
export const FC2PropTypes = {
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
  height: {
    type: Number,
  },
  textarea: {
    type: Boolean,
    default: false,
  },
  bb: {
    type: String,
  },
  ta: {
    type: String,
  },
  fcType: {
    type: String,
    default: "textfield",
  },
  showLabel: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },

  lw: {
    type: String,
    default: "115px",
  },
  cw: {
    type: String,
    default: "auto",
  },
  highlight: {
    type: Boolean,
    default: false,
  },

  icon: {
    type: String,
    default: "",
  },

  ...FC2CommonProps,
};

export default {
  props: {
    ...FC2PropTypes,
    classDict: {
      type: Object,
      default: () => ({}),
    },
    valued: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    heightC: function () {
      return `${
        this.height
          ? this.height
          : this.textarea
          ? TEXTAREA_HEIGHT
          : INPUT_HEIGHT
      }px`;
    },
  },
};
</script>

<style lang="scss">
.fc2 {
  --fc2-disabled-bc: hsla(0, 0%, 94%, 1);
  --fc2-disabled-bdc: hsla(0, 0%, 80%, 1);

  display: flex;
  // Removing FC2 BC Declaration - This should be controlled from Top Box Widget
  // --fc2-bc: var(--fc2-bc, transparent);
  --fc2-bdc: transparent;
  --fc2-lm: 0px 10px 0px 10px;
  // --fc2-lp: 5px 0 0 0;
  --fc2-lp: 5px 0 6px;

  --fc2-cm: 3px 3px 3px 0px;
  --fc2-cp: 0px 10px;
  --fc2-cf: 1;

  --default-hover-bc: var(--bc-cblue);
  --default-hover-bdc: var(--bc-cblue5);
  --default-focus-bdc: var(--bc-cblue10);

  position: relative;



  &.disabled:not(.no-disabled-style):not(.dbox1) {
    --fc2-bc: var(--fc2-disabled-bc);

    &:hover {
      --default-hover-bc: var(--fc2-disabled-bc);
      --default-hover-bdc: var(--fc2-disabled-bdc);
    }
    &:active,
    &:focus {
      --default-focus-bdc: var(--fc2-disabled-bdc);
    }
  }
  // &.disabled.dbox1 {
  //   // --fc2-bc: var(--fc2-disabled-bc);
  //   &:hover {
  //     background: var(--fc2-disabled-bc);
  //     --default-hover-bc: var(--fc2-disabled-bc);
  //     --default-hover-bdc: var(--fc2-disabled-bdc);
  //   }
  //   &:active,
  //   &:focus {
  //     --default-focus-bdc: var(--fc2-disabled-bdc);
  //   }
  // }

  &.textarea {
  }

  &.changed {
  }

  &.dbox1 {
    --bb: 1px solid transparent !important;
  }
  border-bottom: var(--bb);

  label.fc2-label {
    display: flex;
    color: var(--text-5);
    margin: var(--fc2-lm);
    padding: var(--fc2-lp);
    min-width: var(--fc2-lw);
    width: var(--fc2-lw);

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    justify-content: space-between;
  }
}

.dt-grid-box {
  &:hover {
    .fc2.dbox1 {
      &.disabled {
        --fc2-bc: var(--fc2-disabled-bc);
        --default-hover-bc: var(--fc2-disabled-bc);
        --default-hover-bdc: var(--fc2-disabled-bdc);
      }
    }
  }
}
</style>